$(function() {
//     $.ajax({
//   url: "https://demo.mitco.com/v1/tracks/",
//   type: "GET",
//   data: {
//     manufacturer: "AICHI",
//     model: "FR300"
//   },
//   headers: {
//     "accept": "application/json",
//     "Authorization": "bfb3cc6be5da9c76df6a13dde28a8e7709adc84b7a40b59b0608edc4869b81d0"
//   },
//   success: function(response) {
//     console.log("Success:", response);
//   },
//   error: function(xhr, status, error) {
//     console.error("Error:", error);
//   }
// });


    if (window.matchMedia("(min-width: 992px)").matches) {
        // add arrow if has submneu
        $(".header-bottom .main-menu > ul.menu > li.menu-item:has(ul.sub-menu)").addClass("has-submenu");
        $(".header-bottom .main-menu > ul.menu > li.menu-item.has-submenu").prepend("<span class='dropdown-arrow'></span>");
        // Close submenu when click outside of it
        $(document).click(function(event) {
            if (!$(event.target).closest('.header-bottom .main-menu').length) {
                $('.header-bottom .main-menu ul.menu ul.sub-menu').parent().removeClass("open");
            }
        });
        // show submenu on click
        $(".header-bottom .main-menu > ul.menu > li.menu-item > span").on("click", function() {
            if ($(this).parent().hasClass("open")) {
                $(this).parent().removeClass("open");
            } else {
                $(".header-bottom .main-menu ul.menu li.has-submenu").removeClass("open");
                $(".header-bottom .main-menu ul.menu li.menu-item").removeClass("open");
                $(this).parent().addClass("open");
            }
        })
    }
    // show submenu on hover
    $(".header-bottom .main-menu > ul.menu > li.menu-item.has-submenu").hover(
        function() {
            $(this).addClass("open");
        },
        function() {
            $(this).removeClass("open");
        }
    );

    // Mobile menu button js
    if (window.matchMedia("(max-width: 991px)").matches) {
        $('header.main-header .mobile-menu-btn').click(function() {
            $(this).toggleClass('open');
            $(".header-bottom .main-menu").slideToggle();
            $(".header-bottom .main-menu > ul.menu > li.menu-item > ul.sub-menu").slideUp(400);
            $(".header-bottom .main-menu ul.menu > li.menu-item").removeClass("open");
        });

        $(".header-bottom .main-menu > ul.menu > li.menu-item:has(ul.sub-menu)").each(function() {
            $(this).addClass("has-submenu");
        });

        // Append span into list-item
        $(".header-bottom .main-menu > ul.menu > li.menu-item.has-submenu > ul.sub-menu").before("<span class='mobile-toggle'></span>");
        $(".header-bottom .main-menu ul.menu > li.menu-item > span.mobile-toggle").on("click", function() {
            $(this).next().slideToggle(400);
            $(this).parent().toggleClass("open");
            $(this).parent().siblings().find("ul.sub-menu").slideUp(400);
            $(this).parent().siblings().removeClass("open");
        })
    }

       $('.mobile-serarch .search-icon-wrap').click(function() {
            $(this).toggleClass('open');
            $(".search-strip-header-wrap").slideToggle();
        });
        $(window).on('load resize scroll', function() {
          var header = $('header.main-header').outerHeight() + 'px';
          $('.header-space').css('margin-top', header);
        });


    // Equipment Search Dropdown Js

    $(".equipment-search .custom-dropdown .dropdown-title").on("click", function() {
        $(this).next().slideToggle(400);
        $(this).parent().toggleClass("open");
        $(this).parent().siblings().removeClass("open");
        $(this).parent().siblings().find(".dropdown-list").slideUp(400);
    });

    $(".equipment-search .custom-dropdown .dropdown-list .list-item").on("click", function() {
        $(this).parent().parent().prev().text($(this).text());
        $(this).parent().parent().slideUp(400);
        $(this).parent().parent().parent().removeClass("open");
    });

    // Close submenu when click outside of it
    $(document).click(function(event) {
        if (!$(event.target).closest('.equipment-search .custom-dropdown').length) {
            $('.equipment-search .custom-dropdown .dropdown-list').slideUp(400);
            $(".equipment-search .custom-dropdown").removeClass("open");
        }
    });




    if (window.matchMedia("(max-width: 767px)").matches) {
        if ($('.featured-product').length > 0) {
            $('.featured-product .product-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                adaptiveHeight: true,
                dots: true,
            });
        }
    }

    // Product-slider
    if ($('.product-info').length > 0) {
        $('.product-info .slider-content').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            arrows: false,
            infinite: false,
            speed: 1000,
            asNavFor: '.slider-thumb',
        });
        $('.product-info .slider-thumb').slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            asNavFor: '.slider-content',
            dots: false,
            arrows: false,
            infinite: false,
            centerMode: false,
            focusOnSelect: true
        });
    }

    // Mobile Filter dropdown
    if (window.matchMedia("(max-width: 767px)").matches) {
        if ($('.info-left').length > 0) {
            $(".info-left .modal-list .list").before("<div class='dropdown-title'>Select...</div>");
            $(".info-left .modal-list .dropdown-title").on("click", function() {
                $(this).next().slideToggle();
            })
            $(".info-left .list .list-item").on("click", function() {
                $(".info-left .modal-list .dropdown-title").text($(this).text());
                $(this).parent().slideUp();
            })
        }
    }

    $(document).on("click", ".list-wrapper .list-item", function() {
        $(this).siblings().removeClass('active')
        $(this).addClass('active')

        if ($(this).parent().hasClass('equipment_search')) {
            $('.manufacture').parents('.custom-dropdown').find('.dropdown-title').text('Manufacture')
            $('.manufacture .list-item').removeClass('active')
            let tag = $(this).attr('data-tag')
            $('.manufacture .list-item').hide()
            $('.manufacture .list-item[data-tag="' + tag + '"]').show()
            $('.manufacture .list-item[data-tag="' + tag + '"]').length ? $('.manufacture').parents('.custom-dropdown').removeClass('disabled') : $('.manufacture').parents('.custom-dropdown').addClass('disabled');
        }

    })


    $(document).on("click", ".serach-btn-wrapper .search-btn", function() {
        let link = $('.list-item.active').last().attr('data-link')
        if (link) {
            let mainOrigin = window.location.origin;
            let mainUrl = mainOrigin + '' + link
            window.location = mainUrl
        }
    });

    $(document).on('click', '.search-strip-section .equipment-type-wrap .ss-list-item', function() {
        const equipment = $(this).text()
        const manufactureLabel = $(this).parents('.search-strip-section').find('.manufacture-wrap .ss-dropdown-title').attr('data-name')
        $(this).parents('.search-strip-section').find('.manufacture-wrap .ss-dropdown-title').html(manufactureLabel)
        const modelLabel = $(this).parents('.search-strip-section').find('.model-number-wrap .ss-dropdown-title').attr('data-name')
        $(this).parents('.search-strip-section').find('.model-number-wrap .ss-dropdown-title').html(modelLabel)

        $(this).parents('.search-strip-section').find('.manufacture-wrap .ss-list-item').hide().removeClass('active')
        $(this).parents('.search-strip-section').find(`.manufacture-wrap .ss-list-item[data-equipment-type="${equipment}"]`).show()
        // $(this).parents('.search-strip-section').find('.model-number-wrap .ss-list-item').hide().removeClass('active')
        // $(this).parents('.search-strip-section').find(`.model-number-wrap .ss-list-item[data-equipment-type="${equipment}"]`).show()
        $(this).parents('.search-strip-section').find('.model-number-wrap').addClass('disabled')
      $(this).parents('.search-strip-section').find('.ss-btn-wrapper').addClass('disabled')
        $(this).parents('.search-strip-section').find('.manufacture-wrap').removeClass('disabled')
        $('.search-strip-section .ss-btn-wrapper .ss-btn').attr('data-link', '')
    })
    $(document).on('click', '.search-strip-section .manufacture-wrap .ss-list-item', function() {
        const equipment = $(this).parents('.search-strip-section').find('.equipment-type-wrap .ss-list-item.active').text()
        const manufacture = $(this).parents('.search-strip-section').find('.manufacture-wrap .ss-list-item.active').text()
        const manufactureLink = $(this).parents('.search-strip-section').find('.manufacture-wrap .ss-list-item.active').attr('data-link')
        const modelLabel = $(this).parents('.search-strip-section').find('.model-number-wrap .ss-dropdown-title').attr('data-name')
        $(this).parents('.search-strip-section').find('.model-number-wrap .ss-dropdown-title').html(modelLabel)

        $(this).parents('.search-strip-section').find('.model-number-wrap .ss-list-item').hide().removeClass('active')
        $(this).parents('.search-strip-section').find(`.model-number-wrap .ss-list-item[data-equipment-type="${equipment}"][data-manufacture="${manufacture}"]`).show()
        $('.search-strip-section .ss-btn-wrapper .ss-btn').attr('data-link', manufactureLink)
      $(this).parents('.search-strip-section').find('.ss-btn-wrapper').addClass('disabled')
      $(this).parents('.search-strip-section').find('.model-number-wrap').removeClass('disabled')
    })

    $(document).on('click', '.search-strip-section .model-number-wrap .ss-list-item', function() {
        const modelLink = $(this).parents('.search-strip-section').find('.model-number-wrap .ss-list-item.active').attr('data-link')
        $('.search-strip-section .ss-btn-wrapper .ss-btn').attr('data-link', modelLink)
$(this).parents('.search-strip-section').find('.ss-btn-wrapper').removeClass('disabled')
    })

    $(document).on('click', '.search-strip-section .ss-btn-wrapper .ss-btn', function() {
        let link = $(this).attr('data-link')
        if (link) {
            let mainOrigin = window.location.origin;
            let mainUrl = mainOrigin + '' + link
            window.location = mainUrl
        }
    })

    $(document).on('click', '#eq-search-popup.eq-search-popup-wrap .equipment-type-wrap .eqsearch-list-item', function() {
        const equipment = $(this).text()
        const manufactureLabel = $(this).parents('.eq-search-popup-wrap').find('.manufacture-wrap .eqsearch-popup-dropdown-title').attr('data-name')
        $(this).parents('.eq-search-popup-wrap').find('.manufacture-wrap .eqsearch-popup-dropdown-title').html(manufactureLabel)
        const modelLabel = $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-popup-dropdown-title').attr('data-name')
        $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-popup-dropdown-title').html(modelLabel)

        $(this).parents('.eq-search-popup-wrap').find('.manufacture-wrap .eqsearch-list-item').hide().removeClass('active')
        $(this).parents('.eq-search-popup-wrap').find(`.manufacture-wrap .eqsearch-list-item[data-equipment-type="${equipment}"]`).show()
        // $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-list-item').hide().removeClass('active')
        // $(this).parents('.eq-search-popup-wrap').find(`.model-number-wrap .eqsearch-list-item[data-equipment-type="${equipment}"]`).show()
        $('.eq-search-popup-wrap .popup-btn a').attr('href', 'javascript:void(0)');
      $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap').addClass('disabled')
      $(this).parents('.eq-search-popup-wrap').find('.popup-btn').addClass('disabled')
        $(this).parents('.eq-search-popup-wrap').find('.manufacture-wrap').removeClass('disabled')
    })
    $(document).on('click', '.eq-search-popup-wrap .manufacture-wrap .eqsearch-list-item', function() {
        const equipment = $(this).parents('.eq-search-popup-wrap').find('.equipment-type-wrap .eqsearch-list-item.active').text()
        const manufacture = $(this).parents('.eq-search-popup-wrap').find('.manufacture-wrap .eqsearch-list-item.active').text()
        const manufactureLink = $(this).parents('.eq-search-popup-wrap').find('.manufacture-wrap .eqsearch-list-item.active').attr('data-link')
        const modelLabel = $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-popup-dropdown-title').attr('data-name')
        $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-popup-dropdown-title').html(modelLabel)

        $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-list-item').hide().removeClass('active')
        $(this).parents('.eq-search-popup-wrap').find(`.model-number-wrap .eqsearch-list-item[data-equipment-type="${equipment}"][data-manufacture="${manufacture}"]`).show()
        $('.eq-search-popup-wrap .popup-btn a').attr('href', manufactureLink)
      $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap').removeClass('disabled')
      $(this).parents('.eq-search-popup-wrap').find('.popup-btn').addClass('disabled')
    })

    $(document).on('click', '.eq-search-popup-wrap .model-number-wrap .eqsearch-list-item', function() {
        const modelLink = $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-list-item.active').attr('data-link')
        $('.eq-search-popup-wrap .popup-btn a').attr('href', modelLink)
      $(this).parents('.eq-search-popup-wrap').find('.popup-btn').removeClass('disabled')

    })

    $(document).on('click', '#logo-cards-popup.eq-search-popup-wrap .equipment-type-wrap .eqsearch-list-item', function() {
        const equipment = $(this).text()
        const manufacture = $(this).parents('.eq-search-popup-wrap').find('.manufacture-wrap .eqsearch-list-item.active').text()
        const modelLabel = $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-popup-dropdown-title').attr('data-name')
        $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-popup-dropdown-title').html(modelLabel)
        $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap .eqsearch-list-item').hide().removeClass('active')
        $(this).parents('.eq-search-popup-wrap').find(`.model-number-wrap .eqsearch-list-item[data-equipment-type="${equipment}"][data-manufacture="${manufacture}"]`).show()
        $('.eq-search-popup-wrap .popup-btn a').attr('href', 'javascript:void(0)')
      $(this).parents('.eq-search-popup-wrap').find('.model-number-wrap').removeClass('disabled')
      $(this).parents('.eq-search-popup-wrap').find('.popup-btn').addClass('disabled')
    })

    $(document).on('click', '.home-logo-card .card .card-inner', function() {
        const manufacture = $(this).attr('data-name');
        console.log(manufacture)
        $(`#logo-cards-popup .manufacture-wrap .eqsearch-list-item`).removeClass('active')
        $(`#logo-cards-popup .manufacture-wrap .eqsearch-list-item[data-manufacture="${manufacture}"]`).addClass('active')
       const manufactureLabel = $('#logo-cards-popup .equipment-type-wrap .eqsearch-popup-dropdown-title').attr('data-name')
       $('#logo-cards-popup .equipment-type-wrap .eqsearch-popup-dropdown-title').html(manufactureLabel)
        const modelLabel = $('#logo-cards-popup .model-number-wrap .eqsearch-popup-dropdown-title').attr('data-name')
        $('#logo-cards-popup .model-number-wrap .eqsearch-popup-dropdown-title').html(modelLabel)
      $('#logo-cards-popup .model-number-wrap,#logo-cards-popup .popup-btn').addClass('disabled')
    })

    $(document).on('click', '.collection-dropdown-wrap .collection-list-item',function() {
        const link = $(this).attr('data-link')
        if (link) {
            let mainOrigin = window.location.origin;
            let mainUrl = mainOrigin + '' + link
            window.location = mainUrl
        }
    })

    //  function moveShadowForm(){
    //     const app=document.querySelector('#app-embed');
    //     const shadow=app?.shadowRoot;
    //     const form=shadow?.querySelector('form');
    //     const target=document.querySelector('#myForm');
    //     if(form&&target){
    //         shadow.querySelectorAll('style').forEach(s=>document.head.appendChild(s.cloneNode(true)));
    //         target.appendChild(form);
    //         console.log('✅ Form moved');
    //     }
    //     }

    //     new MutationObserver(()=>{
    //     const a=document.querySelector('#app-embed');
    //     if(a?.shadowRoot?.querySelector('form')){
    //         moveShadowForm();
    //         observer.disconnect();
    //     }
    //     }).observe(document,{childList:true,subtree:true});

    //     document.addEventListener('DOMContentLoaded',moveShadowForm);


    
});

$(document).on('submit', 'form#cart', function (e) {
  if ($('.cart-bottom .cart__checkout-button').hasClass('disabled')) {
    e.preventDefault();
    e.stopImmediatePropagation(); // Ensures no other submit handlers run
    console.log('Checkout prevented due to disabled state');
  }
});
 
$(document).on('change', '.cart__ctas_left input', function () {
  const isChecked = $(this).is(':checked');
  $('.cart-bottom .cart__checkout-button').toggleClass('disabled', !isChecked);
});



$(document).ready(function() {
    $(".eqsearch-popup-dropdown-title").on("click", function() {
        $(this).next().slideToggle(400);
        $(this).parent().toggleClass("open");
        $(this).parent().siblings().removeClass("open");
        $(this).parent().siblings().find(".eqsearch-popup-dropdown-list").slideUp(400);
    });

    $(".eqsearch-popup-dropdown-list .eqsearch-list-item").on("click", function() {
        $(this).parent().parent().prev().text($(this).text());
        $(this).parent().parent().slideUp(400);
        $(this).parent().parent().parent().removeClass("open");
        $(this).parents('.eqsearch-popup-dropdown').find('.eqsearch-list-item').removeClass('active')
        $(this).addClass('active')
    });

    $(".ss-dropdown-title").on("click", function() {
        $(this).next().slideToggle(400);
        $(this).parent().toggleClass("open");
        $(this).parent().siblings().removeClass("open");
        $(this).parent().siblings().find(".ss-dropdown-list").slideUp(400);
    });

    $(".ss-dropdown-list .ss-list-item").on("click", function() {
        $(this).parent().parent().prev().text($(this).text());
        $(this).parent().parent().slideUp(400);
        $(this).parent().parent().parent().removeClass("open");
        $(this).parents('.ss-dropdown').find('.ss-list-item').removeClass('active')
        $(this).addClass('active')
    });

    $(".collection-dropdown-title").on("click", function() {
        $(this).next().slideToggle(400);
        $(this).parent().toggleClass("open");
        $(this).parent().siblings().removeClass("open");
        $(this).parent().siblings().find(".collection-dropdown-list").slideUp(400);
    });

    $(".collection-dropdown-title .collection-list-item").on("click", function() {
        $(this).parent().parent().prev().text($(this).text());
        $(this).parent().parent().slideUp(400);
        $(this).parent().parent().parent().removeClass("open");
    });

});